import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=c5b0fec6&scoped=true&"
import script from "./SideMenu.vue?vue&type=script&lang=js&"
export * from "./SideMenu.vue?vue&type=script&lang=js&"
import style0 from "styles/components/sideMenu.css?vue&type=style&index=0&id=c5b0fec6&scoped=true&lang=css&"
import style1 from "./SideMenu.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b0fec6",
  null
  
)

export default component.exports